import React from 'react';

import { Value } from '../common/Content.jsx';
import { TypeConfig as CellItemMetaTypeConfig } from '../common/CellItemMeta.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

function _Meta(props) { return <Value {...props} value={props.content} /> }
const Meta = Token.withContentTokenParsing(_Meta, {}, (props, keyword, options) => {
    if (!props.itemData) {
        return '';
    }
    return Token.TypeParsing.inventory(props, keyword, options);
});
const Tokens = (data) => {
    return [
        Token.getWrappedTokenConfig('Artist Name', Token.Artist.Name),
        Token.getWrappedTokenConfig('Artist Lifespan', Token.Artist.Lifespan),
        Token.getWrappedTokenConfig('Title', Token.Inventory.Title),
        Token.getEditionInfoTokenConfig(),
        Token.getWrappedTokenConfig('Created Date', Token.Date),
        Token.getWrappedTokenConfig('Medium', Token.Inventory.Medium),
        Token.getWrappedTokenConfig('Signature Placement', Token.Inventory.Signature),
        Token.getDimensionsTokenConfig('Dimensions', Token.Inventory.Dimensions),
        Token.getDimensionsTokenConfig('Alternate Dimensions', Token.Inventory.AlternateDimensions),
        Token.getWrappedTokenConfig('Framing', Token.Inventory.Framed),
        Token.getWrappedTokenConfig('Inventory Number', Token.Inventory.Number),
        Token.getWrappedTokenConfig('SKU', Token.Inventory.SKU),
        Token.getWrappedTokenConfig('Location', Token.Inventory.Location),
        Token.getCurrencyTokenConfig('Retail Price', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Inventory.Price),
        Token.getAlternatePricesTokenConfig(),
        Token.getWrappedTokenConfig('Price Override', Token.Inventory.DisplayPrice),
        Token.getSoldTokenConfig(),
        Token.getStatusIndicatorTokenConfig(),
        Token.getWrappedTokenConfig('Notes', Token.Notes),
        Token.getWrappedTokenConfig('Private Notes', Token.PrivateNotes),
        Token.getWrappedTokenConfig('Provenance', Token.Inventory.Provenance),
        { display: 'Artist Biography', token: Token.Artist.Biography },
    ]
};
const TypeConfig = {
    defaultDesign: (data) => `
${Utilities.wrapTextForEditor({ text: `{${Token.Artist.Name}("before":"","after":"")}`, token: Token.Artist.Name })}
<p class="p">${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Title}("before":"","after":"")}`, textExtras: `style="display:inline;font-style:italic;"`, token: Token.Inventory.Title, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Edition}("limited":"${Utilities.Inventory.getEditionFormatString('limited')}","unlimited":"${Utilities.Inventory.getEditionFormatString('unlimited')}")}`, textExtras: `style="display:inline;"`, token: Token.Inventory.Edition, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Date}("before":", ","after":"")}`, textExtras: `style="display:inline;"`, token: Token.Date, wrapWithTag: false })}</p>
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Medium}("before":"","after":"")}`, token: Token.Inventory.Medium })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Signature}("before":"Signature: ","after":"")}`, token: Token.Inventory.Signature })}
<p class="p">${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Dimensions}("before":"","after":"")}`, textExtras: `style="display:inline;"`, token: Token.Inventory.Dimensions, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.AlternateDimensions}("before":" (","after":")")}`, textExtras: `style="display:inline;"`, token: Token.Inventory.AlternateDimensions, wrapWithTag: false })}</p>
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Framed}("before":"","after":"")}`, token: Token.Inventory.Framed })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Number}("before":"Inventory #: ","after":"")}`, token: Token.Inventory.Number })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.SKU}("before":"SKU: ","after":"")}`, token: Token.Inventory.SKU })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Price}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Inventory.Price })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.DisplayPrice}("before":"","after":"")}`, token: Token.Inventory.DisplayPrice })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Location}("before":"","after":"")}`, token: Token.Inventory.Location })}
${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Provenance}("before":"","after":"")}`, token: Token.Inventory.Provenance })}`,
    panel: {
        block: (data, defaultDesign) => CellItemMetaTypeConfig.panel.block(defaultDesign || TypeConfig.defaultDesign(data)),
        style: CellItemMetaTypeConfig.panel.style
    }
};

export {
    Meta as Component,
    Tokens,
    TypeConfig
}